import { useState } from "react";
import { Link } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { AuthShell } from "@/components/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(apiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Forgot password" subtitle="Enter your work email and we'll send you a reset link.">
      {sent ? (
        <div className="rounded-xl border border-border p-6 space-y-3" data-testid="forgot-success">
          <MailCheck className="w-8 h-8 text-accent" />
          <p className="font-semibold">Check your inbox</p>
          <p className="text-sm text-muted-foreground">
            If an account exists for <span className="font-mono">{email}</span>, a password reset link is on its way. It expires in 1 hour.
          </p>
          <Link to="/login" className="text-sm text-primary underline" data-testid="forgot-back-to-login">Back to sign in</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="email">Work Email</Label>
            <Input id="email" type="email" value={email} required className="h-11" data-testid="forgot-email-input"
              onChange={(e) => setEmail(e.target.value)} placeholder="you@skanovix.com" />
          </div>
          {error && <p className="text-sm text-destructive" data-testid="forgot-error">{error}</p>}
          <Button type="submit" disabled={loading} className="w-full h-11 rounded-lg font-semibold" data-testid="forgot-submit-button">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Send reset link"}
          </Button>
          <p className="text-sm text-center text-muted-foreground">
            Remembered it? <Link to="/login" className="text-primary underline" data-testid="forgot-login-link">Sign in</Link>
          </p>
        </form>
      )}
    </AuthShell>
  );
}
